<div class="tw-rounded-sm tw-border-[1px] tw-border-gray-500">
  <pre><code [highlight]="content.code"></code></pre>

</div>
<div class="tw-mt-3 tw-text-sm tw-text-center tw-text-gray-500">{{content.caption}}</div>